
import { Link } from 'react-router-dom';

const SolutionsSection = () => {
  return (
    <section className="py-20 md:py-32 bg-gray-light/5">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="text-center mb-16 md:mb-20">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-primary-dark mb-4 md:mb-6">
            Nos Solutions Locales
          </h2>
          <p className="text-base md:text-lg lg:text-xl text-gray-dark max-w-3xl mx-auto leading-relaxed">
            Des accompagnements personnalisés pour répondre aux besoins spécifiques de chaque agglomération
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 md:gap-16">
          {/* Particuliers Card */}
          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-lg hover:shadow-2xl transition-all duration-300">
            <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-primary-light/20 rounded-2xl mb-5 md:mb-6">
              <i className="ri-group-line text-3xl md:text-4xl text-primary"></i>
            </div>
            <h3 className="text-2xl md:text-3xl font-bold text-primary-dark mb-4 md:mb-6">
              Pour les Particuliers
            </h3>
            <p className="text-sm md:text-base lg:text-lg text-gray-dark leading-relaxed mb-6 md:mb-8">
              Vous avez des projets, des objectifs, des besoins ? De multiples solutions existent dans votre agglomération. Nous vous aidons à les identifier et à en bénéficier facilement.
            </p>
            <ul className="space-y-3 md:space-y-4 mb-8 md:mb-10">
              {[
                'Transports et mobilité au quotidien',
                'Aides pour la mobilité réduite',
                'Insertion sociale et accompagnement',
                'Solutions immobilières et logement',
                'Automobile et déplacements',
                'Éducation et formation',
                'Alimentation et circuits courts',
                'Santé, soins et bien-être',
                'Sport et vie associative',
              ].map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center bg-primary rounded-full flex-shrink-0 mt-0.5 md:mt-1">
                    <i className="ri-check-line text-white text-xs md:text-sm"></i>
                  </div>
                  <span className="text-sm md:text-base text-gray-dark">{item}</span>
                </li>
              ))}
            </ul>
            <Link
              to="/particuliers"
              className="inline-flex items-center gap-2 text-primary font-semibold text-sm md:text-base border-2 border-primary px-6 md:px-8 py-2.5 md:py-3 rounded-full hover:bg-primary hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              En savoir plus
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          {/* Professionnels Card */}
          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-lg hover:shadow-2xl transition-all duration-300">
            <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-primary-light/20 rounded-2xl mb-5 md:mb-6">
              <i className="ri-briefcase-line text-3xl md:text-4xl text-primary"></i>
            </div>
            <h3 className="text-2xl md:text-3xl font-bold text-primary-dark mb-4 md:mb-6">
              Pour les Professionnels
            </h3>
            <p className="text-sm md:text-base lg:text-lg text-gray-dark leading-relaxed mb-6 md:mb-8">
              Artisans, TPE, PME, libéraux, micro-entrepreneurs, cadres ou dirigeants : accédez à des solutions d'accompagnement, de formation et de développement adaptées à votre activité.
            </p>
            <ul className="space-y-3 md:space-y-4 mb-8 md:mb-10">
              {[
                { label: 'Artisans', desc: 'Gestion client et outils administratifs' },
                { label: 'TPE / PME', desc: 'Externalisation et montée en compétences' },
                { label: 'Libéraux', desc: 'Secrétariat et assistance directionnelle' },
                { label: 'Micro-entrepreneurs', desc: 'Formation et réseau local' },
                { label: 'Cadres', desc: 'Formation managériale et réseau' },
                { label: 'Dirigeants', desc: 'Conseil stratégique et gouvernance' },
              ].map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center bg-primary rounded-full flex-shrink-0 mt-0.5 md:mt-1">
                    <i className="ri-check-line text-white text-xs md:text-sm"></i>
                  </div>
                  <div>
                    <span className="text-sm md:text-base font-semibold text-primary-dark">{item.label}</span>
                    <span className="text-sm md:text-base text-gray-dark"> • {item.desc}</span>
                  </div>
                </li>
              ))}
            </ul>
            <Link
              to="/professionnels"
              className="inline-flex items-center gap-2 text-primary font-semibold text-sm md:text-base border-2 border-primary px-6 md:px-8 py-2.5 md:py-3 rounded-full hover:bg-primary hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Découvrir nos solutions
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolutionsSection;
